<app-title-pages-component [pageData]="pageData()"></app-title-pages-component>

<app-table-component
  [columns]="columnDefinitions"
  [data]="clients"
  [onEdit]="editClient"
  [onAdd]="addClient"
  [onDelete]="showConfirmDeleteDialog"
  [editMode]="showBtn"
  [menu]="activateMenu"
  [options]="opciones"
  [labelForSearch]="clientsComponent()?.searchClientInstruction || 'Buscar cliente'"
  [actionsIcons]="iconActions"
  [isServerPaginated]="true"
  [totalItemsOverride]="totalElements"
  [itemsPerPage]="pageSize"
  [currentPageInput]="currentPage + 1"
  (itemsPerPageChange)="onItemsPerPageChange($event)"
  (pageChange)="onPageChange($event)"
  (searchChange)="onSearchChange($event)"
  [loading]="loading"
></app-table-component>

@if(showModal){
  <app-confirm-delete-dialog
    [message]="message"
    (confirmar)="handleDelete()"
    (cancelar)="handleCancelDeleteDialog()"
  ></app-confirm-delete-dialog>
}


